exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "button[data-v-e657ebd4] {\n  transition: all 0.2s;\n  display: flex;\n  justify-content: center;\n}\nbutton[data-v-e657ebd4]:disabled {\n  pointer-events: none;\n  opacity: 0.6;\n}\nbutton .checkmark[data-v-e657ebd4] {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 20px;\n  margin-left: 15px;\n}\nbutton .checkmark[data-v-e657ebd4]::after {\n  content: \"\";\n  display: block;\n  width: 10px;\n  height: 18px;\n  margin-top: -10px;\n  border: solid #fff;\n  border-width: 0 2px 2px 0;\n  transform: rotate(45deg);\n}", ""]);

// exports
